<template>
  <div id="app">
    <div class="ddrop-processing-overlay" v-if="formSubmitting"></div>
    <div class="ddrop-formloading" v-if="questions.length === 0">
      <h4><i class="fas fa-spinner fa-spin"></i> Loading form...</h4>
    </div>

    <form v-bind:action="actionUrl" 
          ref="form"
          enctype="multipart/form-data" 
          method="post"
          v-on:submit.prevent="submitForm"
          v-bind:class="{ 'grayed-out' : formSubmitting }"
          :disabled="formSubmitting"
          >
    
    <div class="alert alert-danger" role="alert" v-if="returnmessage !== null">
      {{ returnmessage }}
    </div>

    <div class="alert alert-danger" id="error-summary" role="alert" aria-live="assertive" tabindex="-1" v-if="errors.length > 0">
      Please correct the following errors:
      <ul class="pl-3 mt-3 mb-0">
        <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
      </ul>
    </div>

    <div class="ddrop-container">
      <div class="row">
        <div class="col-12">
          <div v-for="(questionObj, index) in formQuestions" v-bind:key="index">
            <component :ref="questionObj.msqID.toString()"
                       v-bind:is="getFormComponentType(questionObj)"
                       v-bind:question="questionObj">
            </component>
          </div>

          <input name="surname31" id="surname31" type="text" class="form-surname">
          <div class="form-group" v-if="questions.length">
            <button type="submit" class="btn btn-primary btn-block" :disabled="formSubmitting" v-html="submitButtonHtml"></button>
          </div>
        </div>
      </div>
    </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

/* eslint-disable no-unused-vars */
import FormInput from './components/FormInput.vue'
import FormFile from './components/FormFile.vue'
import FormSelect from './components/FormSelect.vue'
import FormCheckboxList from './components/FormCheckboxList.vue'
/* eslint-enable no-unused-vars */

export default {
  name: 'App',
  data() {
    return {
      questions: [],
      errors: [],
      returnmessage: null,
      formSubmitting: false,
    }
  },

  created() {
    fetch(this.configUrl)
        .then((res) => res.json())
        .then((json) => {
          this.questions = json.questions
    })
  },

  methods: {
    getActionUrl() {
      return this.actionUrl = this.$refs.root.dataset.actionurl;
    },
    getConcreteFormBID() {
      return this.bID = parseInt(this.$refs.root.dataset.bid) || 0;
    },
    // generate question name (for input elements) from a question
    makeQuestionId: function (question) {
        return 'Question' + question.msqID;
    },
    submitForm() {

        // Regular expression for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
        const form = this.$refs.form;
        const formData = new FormData(form);

        // Set formSubmitting to true to change submit button
        this.formSubmitting = true;

        // Clear previous errors
        this.errors = [];

        // Check if required fields are answered
        this.questions.forEach((question) => {

          let valueToCheck;

            // Handle different field types
            switch (question.type) {
              case 'text':
              case 'textarea':
              case 'select':
                valueToCheck = question.answer;
                break;
              case 'file':
                valueToCheck = question.answer && question.answer.length > 0 ? question.answer : null;
                break;
              case 'checkboxlist':
                valueToCheck = Array.isArray(question.answer) && question.answer.length > 0 ? question.answer : null;
                break;
              default:
                valueToCheck = question.answer; // Fallback for other field types
            }

            // Check if required and not filled
            if (question.required && !valueToCheck) {
                question.error = 'This field is required.';
                this.errors.push(`${question.question} is required`);
            } 
            // If it's an email field, check if it's a valid email format
            else if (question.type === 'email' && valueToCheck && !emailRegex.test(valueToCheck)) {
                question.error = 'Entire a valid email address.';
                this.errors.push(`${question.question} must be an email address.`);
            }
            else {
                question.error = null; // Clear any previous error
            }

        });

        // If there are errors, stop the submission and show the error messages
        if (this.errors.length > 0) {
            this.formSubmitting = false;

            // Focus on the error summary or the first invalid input
            this.$nextTick(() => {
              
                // Focus on the error summary if it exists
                const errorSummary = document.getElementById('error-summary');
                if (errorSummary) {
                    errorSummary.focus();
                }
            });
            return;
        }


        // Loop through FormData and log each field and its value
        // for (let [name, value] of formData.entries()) {
        //     console.log(`Field name: ${name}, Value: ${value}`);
        // }

        // Post to server
        axios.post(this.actionUrl, formData)
        .then( (response) => {
            const data = response.data;
            window.location.replace(data.redirectPath);
        })
        .catch( (error) => {
          if(error.response) {
            const data = error.response.data;
            this.returnmessage = data.returnmessage;
            this.errors = data.errors;
            this.formSubmitting = false;
            this.processFormErrors();
          }
        });
    },
    processFormErrors() {
      for(var qId in this.errors) {
          let question = this.questions.find(function (q) {
              return q.qID === qId;
          });
          if (question !== undefined) {
                question.error = this.errors[qId];
            } else {
                console.warn("Cannot display error for " + question + " with qID of " + qId);
          }
      }
    },
    getFormComponentType: function(question) {
        let componentType = "FormInput"
        switch(question.type) {
          case "text":
            componentType = 'FormInput';
            break;
          case "file":
            componentType = 'FormFile';
            break;
          case "checkboxlist":
            componentType = 'FormCheckboxList';
            break;
          case "select":
            componentType = 'FormSelect';
            break;
          default:
            componentType = 'FormInput';
        }
        return componentType;
    }
  },

  computed: {
    formQuestions() {
      return this.questions;
    },
    actionUrl() {
      return this.$store.state.actionurl;
    },
    configUrl() {
      return this.$store.state.configurl;
    },
    bID() {
      return this.$store.state.bID;
    },
    formerrors() {
      return this.errors;
    },
    responsemessage() {
      return this.returnmessage;
    },
    submitButtonHtml() {
      return this.formSubmitting ? '<i class="fas fa-circle-notch fa-spin"></i> Processing' : 'Submit entries';
    }
  },

  mounted() {
    //this.getActionUrl();
    //this.getConcreteFormBID();
  },

  components: {
    FormInput,
    FormFile,
    FormSelect,
    FormCheckboxList
  },
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
}
.ddrop-processing-overlay {
    position:absolute;
    width:100%;
    height:100%;
    background-color: rgba($color: #ffffff, $alpha: 0.5);
    z-index: 1000;
}
.ddrop-formloading {
  min-height:200px;
}
.grayed-out {
   filter: grayscale(90%);
}
.red-alert {
    border-color: red !important;
}
.span-error {
   color:#721c24 !important;
}
.form-surname {
  position:absolute;
  left:-100000px;
}

.text-muted.small.error {
	color: red !important;
}
.has-error input,.has-error file, .has-error textarea, .has-error select {
  border: 2px solid red; 
}
</style>
